/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PickList = (function () {

    function PickList () {

        Monet.UI.Fields.Base.apply (this, arguments);

        this.createBaseStructure ();

        this.defaultValue = ' ';
        this.input = null;
        this.suffix = null;
        this.isAReactField = false;

        var postRenderListeners = [];

        this.setFieldDomains = function (fieldDomains){
            this.fieldDomains = fieldDomains;
        };

        this.setLookUpEntity = function (entity) {
            this.lookUpEntity = entity;
        };

        this.setDisplayKey = function (column) {
            this.displayKey = column;
        };

        this.setDefaultValue = function (value) {
            this.defaultValue = value;
        };

        this.setFieldId = function (id) {
            this.fieldId = id;
        };

        this.addPostRender = function(listener) {
            postRenderListeners.push(listener);
        };

        this.setIfIsAReactField = function (boolean) {
            this.isAReactField = boolean;
        };

        this.setData = function (elements) {
            this.input.options.length = 0;
            if (elements) {
                for (var i = 0, l = elements.length; i < l; i++) {
                    var option = document.createElement ('option');
                    var translatedDescription = Monet.I18n.getResourcesByKey (elements[i].description);
                    
                    option.appendChild (document.createTextNode (translatedDescription));
                    option.value = elements[i].value;

                    if (i === 0) {
                        option.selected = 'selected';
                    }
                    
                    if (this.selectedValue === elements[i].value) {
                        option.selected = 'selected';
                    }

                    this.input.appendChild (option);

                    try {
                        if(this.loadingOption.parentNode !== null) {
                            this.input.removeChild (this.loadingOption);
                        }
                    } catch (err) {
                        console.log (err);
                    }

                }
            }

        }.bind(this);

        this.setSelectedValue = function (value) {
            this.selectedValue = value || this.selectedValue;
            this.selectedValue = this.selectedValue || '';

            if(this.input){
                var options = this.input.options;

                for(var i = 0, length = options.length; i < length;  i++) {
                    var option = options[i];
                    if(option.value.trim() === this.selectedValue.trim() || (this.selectedValue  instanceof Array && this.selectedValue.indexOf(option.value) !== -1)){
                        option.selected = true;
                    }
                }
            }

        };

        this.dataIsFieldDomain = function () {

            return !this.displayKey;

        };

        this.getFilterValue = function (){
            var value = this.getValue();
            if(this.lookUpEntity &&  this.value) {
                return value.id;
            } else {
                return value;
            }
        };

        this.getValue = function () {

            if(this.input){
                this.value = (this.input.value).trim();
            }

            if (this.rootEl.querySelector('option.isLoading')) {
                return this.currentValue;
            }

            if (this.value && this.displayKey) {
                try {
                    this.value = JSON.parse(this.input.value);
                } catch (e) {
                    console.log("[MONET] Cannot convert this.input.value to JSON");
                }
            }

            if (this.lookUpEntity &&  this.value) {
                this.value = { id: this.value };
            }

            return this.value;

        };

        this.setValue = function (value) {

            if(value &&  this.lookUpEntity){
                value = value.id.toString();
            }

            this.value = value || '';

            if (value) {
                this.currentValue = value;
                this.selectedValue = value;
            } else {
                this.input.value = '';
            }
            this.setSelectedValue();
        };

        this.clear = function () {
            var clearValue = this.defaultValue || ' ';
            this.setValue(clearValue);
            this.input.value = clearValue;
        };

        this.createElement = function () {
            this.rootEl.className = "pickListFieldRoot";
            this.input = document.createElement ('select');

            this.input.className = 'pickListField';

            this.loadingOption = document.createElement ('option');
            this.loadingOption.appendChild (
                document.createTextNode (
                    Monet.I18n.getResourcesByKey ('Monet.UI.Fields.PickList.Loading')
                )
            );
            this.loadingOption.className = 'isLoading';
            this.loadingOption.selected = 'selected';

            this.input.appendChild(this.loadingOption);

            this.rootEl.appendChild(this.input);

            if(this.suffix) {
                this.input.className += " suffixed"; 
                const suffixlabel = document.createElement("label");
                suffixlabel.className = "suffix";
                const suffixTextNode = document.createTextNode(Monet.I18n.getResourcesByKey(this.suffix));
                suffixlabel.appendChild(suffixTextNode);
                this.rootEl.appendChild(suffixlabel);
            }

        };

        this.setSuffix = function() {
            if(this.meta && this.meta.suffix) {
                this.suffix = this.meta.suffix;
            }
        }

        this.checkPickListTypeAndRequestData = function (callback) {

            if (this.displayKey) {
                this.requestData (callback);
            } else {
                if (!this.fieldDomains ){
                    this.requestFieldDomain (callback);
                } else {
                    callback(this.fieldDomains);
                }

            }

        };

        this.requestFieldDomain = function (callback) {
            
            if (!this.fieldId) {
                return;
            }

            var request = new Monet.Ajax ();
            request.url = 'Field/' + this.fieldId + '/FindDomains';
            request.success = callback;
            request.send();

        };

        this.successOfRequestData = function (scope) {
            return function (data) {

                scope.renderItemsList (data);
                scope.setSelectedValue(scope.selectedValue || scope.defaultValue);
                try {
                    scope.loadingOption.value = '';
                    scope.loadingOption.innerHTML = '';
                    scope.loadingOption.removeAttribute('class');

                    scope.postRenderList();

                } catch (err) {
                    console.log (err);
                }
            };
        }(this);


        this.customFilter = "{}";
        this.customCriteria = '{"firstResult":0,"maxResults":100}';

        this.setCustomFilter = function(customFilter) {
            this.customFilter = customFilter;
        };

        this.setCustomCriteria = function(customCriteria) {
            this.customCriteria = customCriteria;
        };

        this.setCustomUrl = function(customUrl) {
            this.customUrl = customUrl;
        };

        this.requestData = function (callback) {

            var request = new Monet.Ajax ();
            request.url = this.customUrl || (this.lookUpEntity + "/restrictions?criteria=" + this.customCriteria);
            request.method = 'POST';
            request.data = this.customFilter;
            request.success = callback;
            request.send();

        };

        this.renderItemsList = function (scope) {
            return function (data) {

                if (data) {
                    for (var i = 0, l = data.length; i < l; i++) {

                        var option = document.createElement ('option');

                        var value = data[i][scope.displayKey];
                        var id =  data[i].id;

                        //Caso do picklist com field domain
                        if(!this.displayKey){
                            value = Monet.I18n.getResourcesByKey(data[i].description);
                            id = data[i].value;

                        }

                        option.appendChild (document.createTextNode (value));
                        option.value = id;
                        scope.input.appendChild (option);

                    }
                }

                scope.input.value = scope.currentValue;

            };
        }(this);

        this.setListenerOnChange = function(listenerFn) {
           this.input.addEventListener('change', listenerFn);
        };

        this.render = function () {
            this.setSuffix();
            this.createElement ();
            this.checkPickListTypeAndRequestData (this.successOfRequestData);
            return this.rootEl;

        };

        /**
         * postRender event firer
         *
         * Use this event to interact with picklist after get field domains.
         *
         * @public
         */
        this.postRenderList = function () {

            for(var i=0, length = postRenderListeners.length; i< length ; i++ ){
                postRenderListeners[i]();
            }
        };

        this.removeOption = function(indexToRemove) {
            this.input.removeChild(this.input.options[indexToRemove]);
        };
    
        this.removeOptionByValue = function(value) {
            Object.keys(this.input.options).filter(function(i){
                return this.input.options[i].value === value.toString();
            }.bind(this)).forEach(this.removeOption);
        };

    }

    return PickList;

}());